import { JobDetailsModel } from "../tp-core-types/JobDetailsModel";

export default function isArchivedJob(job:JobDetailsModel){
    return !job.isAvailable;
}